import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  theme: "dark",
  lang: "en",
};

export const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
      return state;
    },
    setLang: (state, action) => {
      state.lang = action.payload;
      return state;
    },
  },
});

const generalReducer = generalSlice.reducer;

export const { setTheme, setLang } = generalSlice.actions;

export default generalReducer;
